import Component from '@glimmer/component';

import CButton from 'rise-ui/components/c-button.gjs';
import string from 'rise-ui/helpers/string.js';

export default class CatalogDetailMetaComponent extends Component {
  <template>
    {{#if false}}
    <div class="id-catalog-record__meta">
      <h4 class="c-section-title id-catalog-record__meta-label">
        {{string "record-metadata-heading"}}
      </h4>
      <CButton
        @classMix="id-catalog-record__button--download-catalog-meta"
        @disabled={{true}}
        @title="Not yet implemented"
      >
        {{string "record-download-metadata-link"}}
      </CButton>
    </div>
    {{/if}}
  </template>
}
